import brand from "./brand.json";

/**
 * Twilanswer brand colors (logo: public/TwilanswerIconSVG.svg).
 * Edit only src/theme/brand.json — this module exposes helpers + CSS variables.
 */
export { brand };

const CSS_VAR_MAP = {
  "--ta-brand-facet": brand.facet,
  "--ta-brand-mist": brand.mist,
  "--ta-brand-primary": brand.primary,
  "--ta-brand-primary-hover": brand.primaryHover,
  "--ta-brand-primary-active": brand.primaryActive,
  "--ta-brand-on-mist": brand.onMist,
};

/**
 * Paints :root CSS variables for use in plain CSS / Tailwind arbitrary values.
 * Call once at app startup (see index.js).
 */
export function applyBrandCssVariables() {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  Object.entries(CSS_VAR_MAP).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}
